import React, { Component } from "react";
import PropTypes from "prop-types";

class Switcher extends Component {
	constructor(props) {
		super(props);
		let active = 0;
		props.options.forEach((option, index) => {
			if (props.initialValue && option.value === props.initialValue) {
				active = index;
			}
		});
		this.state = {
			active: active,
		};
	}

	changeValue = (index, option) => {
		this.setState({ active: index });
		if (this.props.onSelect) {
			this.props.onSelect(index, option);
		}
	};

	render() {
		return (
			<div className={`switcher count-${this.props.options.length}`}>
				{this.props.options.map((option, index) => (
					<div
						key={index}
						className={`switcher-option${this.state.active === index ? " on" : ""}`}
						onClick={() => this.changeValue(index, option)}
					>
						{option.label}
					</div>
				))}
			</div>
		);
	}
}
Switcher.propTypes = {
	label: PropTypes.string,
	options: PropTypes.any,
	onSelect: PropTypes.func,
	initialValue: PropTypes.any,
};
export default Switcher;
